import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const updateAgentPoint = createAsyncThunk("AgentPoints/updateAgentPoint", async (data, thunkAPI) => {
  let { schema, user_id, handleSuccess, handleError } = data;
  try {
    const resp = await axios.put(`${process.env.REACT_APP_BASE_URL}api/users/points/${user_id}`, schema, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (handleSuccess) {
      handleSuccess("update");
    }
    return resp.data.userPoint;
  } catch (error) {
    if (error.response) {
      if (handleError) {
        handleError(error.response.data.errorMessage || error.response.data.message);
      }
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      if (handleError) {
        handleError(error.message);
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
